export default function addState(key, object, state, setState) {
    if (state) {
        setState({ ...state, [key]: object });
    } else {
        setState({ [key]: { ...object } });
    }
}
